import React from "react";
import ConfirmationForm from './forms/confirmation-form';
import {confirmation, confirmationLink} from "../../../actions/auth-actions";
import {push} from "react-router-redux";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setNotification} from "../../../actions/notifications-actions";
import {actions} from "react-redux-form";
import * as types from "../../../actions/types";
import {Link} from "react-router-dom";
import qs from "query-string";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class LecturerConfirmation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            confirming: false,
            confirmed: null,
            error: null
        };
    }

    componentWillMount() {
        let params = qs.parse(this.props.location.search);
        if (params['confirmation_token']) {
            this.setState({...this.state, confirming: true});
            this.props.confirmationLink(params['confirmation_token'])
                .then((response) => {
                    if (response.type === types.AUTH_CONFIRMATION_LINK_SUCCESS) {
                        this.setState({...this.state, confirmed: true})
                    } else {
                        if (response.payload.response) {
                            this.setState({...this.state, confirmed: false, error: response.payload.response});
                        } else {
                            this.setState({...this.state, confirmed: false, error: 'Vyskytla se neočekávaná chyba.'});
                        }
                    }
                });

        }
    }

    confirmationFormModel = 'forms.usersConfirmationResend';

    confirmationResend = (values) => {
        this.props.resetValidity(this.confirmationFormModel);
        let promise = new Promise((resolve, reject) => {
            this.props
                .confirmation({ lecturer: values })
                .then((response) => {
                    if (response.type === types.AUTH_CONFIRMATION_SUCCESS) {
                        this.props.setNotification('info','Za několik minut obdržíte e-mail s instrukcemi pro nastavení nového hesla.');
                        this.setState({...this.state, finished: true});
                        resolve();
                    } else {
                        if (response.payload.response) {
                            reject(response.payload.response.errors);
                        } else {
                            this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
                        }
                    }
                })
        });
        this.props.submitFields(this.confirmationFormModel, promise);
    };

    render() {
        if (this.state.confirming) {
            if (this.state.confirmed === true) {
                return (
                    <div className='container text-center'>
                        <div className='alert alert-success'>Uživatelský účet potvrzen!</div>
                        <div>Nyní se můžete <Link to={`/lecturers/sign-in`}>přihlásit</Link></div>
                    </div>
                );
            } else if (this.state.confirmed === false) {
                return (
                    <div className='container text-center'>
                        <div className='alert alert-warning'>
                            { (this.state.error['email'] || []).map((message, index) => (
                                <div key={index}>Email {message}</div>
                            )) }
                            { (this.state.error['confirmation_token'] || []).map((message, index) => (
                                <div key={index}>Potvrzovací token {message}</div>
                            )) }
                        </div>
                        <hr/>
                        <p className='text-center'>
                            <Link to='/sign-in'>Přihlášení</Link><br/>
                            <Link to='/lecturers/registration'>Registrace</Link><br/>
                        </p>
                    </div>
                );
            } else if (this.state.confirmed === null) {
                return (
                    <div className='container text-center'>
                        <div><FontAwesomeIcon spin={true} icon={['far', 'spinner']}/></div>
                    </div>
                );
            }
        }

        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 m-auto'>
                        <h1 className='page-title'>Vyžádání potvrzovacího emailu</h1>
                        <div className='card auth-card'>
                            <div className='card-body'>
                                <ConfirmationForm model={this.confirmationFormModel} onSubmit={this.confirmationResend}/>
                                <small>
                                    <p>Už máte svůj profil? <Link to='/lecturers/sign-in'>Přihlaste se.</Link></p>
                                    <p>Chcete se přihlásit za konkrétní tím? <Link to='/students/sign-in'>Přihlaste se.</Link></p>
                                    <span><Link to='/lecturers/registration'>Registrace</Link></span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        submitFields: actions.submitFields,
        resetValidity: actions.resetValidity,
        setValidity: actions.setValidity,
        setNotification: setNotification,
        push: push,
        confirmation: confirmation,
        confirmationLink: confirmationLink,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LecturerConfirmation);
